import { render, staticRenderFns } from "./BigFive.vue?vue&type=template&id=150344be&scoped=true"
import script from "./BigFive.vue?vue&type=script&lang=js"
export * from "./BigFive.vue?vue&type=script&lang=js"
import style0 from "./BigFive.vue?vue&type=style&index=0&id=150344be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150344be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VProgressCircular,VRadio,VRadioGroup})
